/**
 * Tries to get the name of a user. Name fields have different names in some systems, so this checks for a
 * number of possible property names.
 */
export const getFullName = (({ first_name, last_name, firstName, lastName }) => {
  let name = '';
  if (first_name || last_name) {
    name = `${first_name} ${last_name}`;
  }
  if (firstName || lastName) {
    name = `${firstName} ${lastName}`;
  }
  return name;
});

/**
 * Builds a label string for a user, in the form of "First Last (email)"
 * @returns {string}
 */
export const getUserLabel = (user) => {
  const name = getFullName(user) || user.name;
  return name ? `${name} (${user.email})` : user.email;
};

/**
 * Builds an Autocomplete dropdown option object from a user object.
 *
 * @returns {{id, label: (string|*)}}
 */
export const toUserOption = (user) => {
  if (!user) {
    return null;
  }
  return {
    id: user.email,
    label: getUserLabel(user),
  }
};
